// third-party
import { FormattedMessage } from "react-intl";

// assets
import { Kanban } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  transaction: Kanban,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const transaction: NavItemType = {
  id: "group-transactions",
  title: <FormattedMessage id="page.menu_items_transaction_label" />,
  icon: icons.transaction,
  type: "group",
  children: [
    {
      id: "transaction",
      title: <FormattedMessage id="page.menu_items_transaction_label" />,
      type: "item",
      url: "/transaction/list",
      icon: icons.transaction,
    },
  ],
};

export default transaction;
